/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatAgentPersona
 */
export interface ChatAgentPersona {
    /**
     * Unique identifier of the agent persona
     * @type {string}
     * @memberof ChatAgentPersona
     */
    id: string;
    /**
     * Display name of the chat agent
     * @type {string}
     * @memberof ChatAgentPersona
     */
    name: string;
    /**
     * URL of the agent's avatar image
     * @type {string}
     * @memberof ChatAgentPersona
     */
    avatarUrl: string;
    /**
     * Current availability status of the agent
     * @type {string}
     * @memberof ChatAgentPersona
     */
    availabilityStatus: ChatAgentPersonaAvailabilityStatusEnum;
    /**
     * The type discriminator for this persona
     * @type {string}
     * @memberof ChatAgentPersona
     */
    type: ChatAgentPersonaTypeEnum;
}


/**
 * @export
 */
export const ChatAgentPersonaAvailabilityStatusEnum = {
    Online: 'ONLINE',
    Offline: 'OFFLINE'
} as const;
export type ChatAgentPersonaAvailabilityStatusEnum = typeof ChatAgentPersonaAvailabilityStatusEnum[keyof typeof ChatAgentPersonaAvailabilityStatusEnum];

/**
 * @export
 */
export const ChatAgentPersonaTypeEnum = {
    ChatClientPersona: 'ChatClientPersona',
    ChatAgentPersona: 'ChatAgentPersona',
    WorkspacePersona: 'WorkspacePersona',
    ChatWorkspaceDomainPersona: 'ChatWorkspaceDomainPersona'
} as const;
export type ChatAgentPersonaTypeEnum = typeof ChatAgentPersonaTypeEnum[keyof typeof ChatAgentPersonaTypeEnum];


/**
 * Check if a given object implements the ChatAgentPersona interface.
 */
export function instanceOfChatAgentPersona(value: object): value is ChatAgentPersona {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('availabilityStatus' in value) || value['availabilityStatus'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ChatAgentPersonaFromJSON(json: any): ChatAgentPersona {
    return ChatAgentPersonaFromJSONTyped(json, false);
}

export function ChatAgentPersonaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatAgentPersona {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'avatarUrl': json['avatarUrl'],
        'availabilityStatus': json['availabilityStatus'],
        'type': json['type'],
    };
}

export function ChatAgentPersonaToJSON(json: any): ChatAgentPersona {
    return ChatAgentPersonaToJSONTyped(json, false);
}

export function ChatAgentPersonaToJSONTyped(value?: ChatAgentPersona | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
        'availabilityStatus': value['availabilityStatus'],
        'type': value['type'],
    };
}

